export const TravelFormatArray = [
  'individual',
  'group',
  'single',
  ] as const;
  
  export type TravelFormat = typeof TravelFormatArray[number];
  